import { computed } from 'vue'
import type { ComputedRef, Ref } from 'vue'
// types
import type { StrapiGlobalSettings, StrapiSingleResponse } from '@ts-strapi/interfaces'
// constants
import { QUIZ_URL_STATE_KEY } from '@composables/tools/default-cta-url.hook'
// hooks
import { useStrapiFetch } from '@api/strapi/use-strapi-fetch.hook'

interface StrapiGlobalSettingsHookReturn {
  refGlobalSettings: ComputedRef<StrapiGlobalSettings | null>
  refPending: Ref<boolean>
  refError: Ref<Error | null>
}

export const useStrapiGlobalSettings = async (): Promise<StrapiGlobalSettingsHookReturn> => {
  const strapiFetch = useStrapiFetch()
  const refQuizUrl = useState<string | null>(QUIZ_URL_STATE_KEY, () => null)

  const { data, pending, error } = await useAsyncData(
    'strapi:global-settings',
    () => strapiFetch<StrapiSingleResponse<StrapiGlobalSettings>>('/global-setting'),
  )

  refQuizUrl.value = data.value?.data?.quizUrl ?? null

  return {
    refGlobalSettings: computed(() => data.value?.data ?? null),
    refPending: pending,
    refError: error as Ref<Error | null>,
  }
}
